module.exports = __webpack_public_path__ + "static/media/slide-2.783646e1.jpg";